import { resolveIcon } from "@/cms/icons";

const DEFAULT_REASONS = [
  {
    icon: "Shield",
    title: "Best Price Guarantee",
    desc: "Unbeatable rates on every booking",
  },
  {
    icon: "Flag",
    title: "Premium Golf Courses",
    desc: "Curated selection of top courses",
  },
  {
    icon: "Zap",
    title: "Instant Confirmation",
    desc: "Book and play without the wait",
  },
  {
    icon: "Headphones",
    title: "Dedicated Concierge",
    desc: "Personal support around the clock",
  },
  {
    icon: "Globe",
    title: "Multi Country Access",
    desc: "Play across 30+ destinations",
  },
  {
    icon: "Lock",
    title: "Secure Booking",
    desc: "Your data and payments protected",
  },
];

export default function ExquraWhyBook({ fields = {} }) {
  const { headline = "Why Book With Exqura", reasons = DEFAULT_REASONS } =
    fields;

  return (
    <section className="bg-white py-5 border-t border-white/5">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
      <div className="bg-[#0B2421] rounded-3xl py-8 px-6 sm:px-8 lg:px-12">
        <div className="">
          <h2 className="text-center text-[#D4AF37] font-bold text-2xl sm:text-3xl lg:text-4xl mb-16">
            {headline}
          </h2>

          <div className="grid grid-cols-2 md:grid-cols-3 lg:grid-cols-6 gap-8">
            {reasons.map((r, i) => {
              const Icon = resolveIcon(r.icon);
              return (
                <div
                  key={i}
                  className="relative flex flex-col items-center text-center px-4"
                >
                  {/* Divider */}
                  {i !== reasons.length - 1 && (
                    <div className="hidden lg:block absolute right-0 top-1/3 -translate-y-1/3 h-24 w-px bg-[#D4AF37]/30" />
                  )}

                  <div className="w-16 h-16 rounded-2xl bg-white/5 border border-[#D4AF37]/30 flex items-center justify-center mb-4">
                    <Icon className="w-7 h-7 text-[#D4AF37]" />
                  </div>

                  <h3 className="text-white font-semibold text-sm sm:text-base mb-2 leading-tight">
                    {r.title}
                  </h3>
                </div>
              );
            })}
          </div>
        </div>
      </div>
      </div>
    </section>
  );
}
